
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/node/publication_landing",
      function () {
        return require("private-next-pages/node/publication_landing.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/node/publication_landing"])
      });
    }
  